import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
export var truncateToTwoDecimals = function truncateToTwoDecimals(num) {
  return Math.round(num * 100) / 100;
};
export var getRate = function getRate(listing, isCoworking, deskMonthlyRate, rateTypeLabel) {
  var _context;
  if (!listing) return "N/A";
  if (isCoworking && deskMonthlyRate) {
    return "$".concat(deskMonthlyRate.toLocaleString(), " /mo");
  }
  var rate = listing.allInclusiveRent || listing.askingRate;
  if (!rate) return "N/A";
  return _concatInstanceProperty(_context = "$".concat(truncateToTwoDecimals(rate).toLocaleString(), " ")).call(_context, rateTypeLabel);
};
export var getSpaceDisplay = function getSpaceDisplay(listing) {
  var floorDisplay = listing.floorDisplay;
  var suiteDisplay = listing.suiteDisplay;
  if (floorDisplay && suiteDisplay) {
    var _context2;
    return _concatInstanceProperty(_context2 = "".concat(floorDisplay, " - ")).call(_context2, suiteDisplay);
  } else if (floorDisplay) {
    return floorDisplay;
  } else if (suiteDisplay) {
    return suiteDisplay;
  }
  return listing.displayAddressWithFloor || "N/A";
};